"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchSettings = void 0;

var _tslib = require("tslib");

var _api = require("../api");

var _types = require("./types");

var fetchSettings = function fetchSettings() {
  return (0, _tslib.__awaiter)(void 0, void 0, void 0, function () {
    var location;
    return (0, _tslib.__generator)(this, function (_a) {
      location = typeof window !== 'undefined' && window.location && window.location.origin;
      return [2
      /*return*/
      , _api.api.get(location + "/" + _types.Endpoints.Settings).then(function (res) {
        return res.data;
      })];
    });
  });
};

exports.fetchSettings = fetchSettings;